<template>
  <div class="about">
    <h1 aria-live="assertive">This is an TEST page</h1>
  </div>
</template>

<script>

  export default {

  }
</script>
